import {
    LIKE_POST,
    UNLIKE_POST,
    BOOKMARK_POST,
    DEL_BOOKMARK_POST
} from "@/store/actions.type"

export default {
    data: () => ({
        saveLoading: false
    }),
    methods: {
        likePost(post) {
            if (!this.isLogedIn) {
                this.$router.push('/account/login/')
                return
            }
                
            if (!post.liked) {
                this.$store.dispatch(LIKE_POST, {
                    postId: post.id,
                    likes_count: post.likes_count + 1
                })
            } else {
                this.$store.dispatch(UNLIKE_POST, {
                    postId: post.id,
                    likes_count: post.likes_count - 1
                })
            }

        },

        save(post) {
            if (!this.isLogedIn) {
                this.$router.push('/account/login/')
                return
            }
                
            if (!post.saved) {
                this.saveLoading = true
                this.$store.dispatch(BOOKMARK_POST, {
                    postId: post.id
                })
                .then(() => {
                    this.saveLoading = false
                })
            } else {
                this.saveLoading = true
                this.$store.dispatch(DEL_BOOKMARK_POST, {
                    postId: post.id
                })
                .then(() => {
                    this.saveLoading = false
                })
            }

        }
    }
}